// Code review - Completed
// Documentation - Completed
import { useEffect, useState } from "react";
import { mainTable } from "../css/Common";
import "react-toastify/dist/ReactToastify.css";
import {
  schoolMasterExportHeaders,
  schoolMasterHeaders,
} from "../components/HeaderAttribute";
import MainLayout from "../components/MainLayout";
import MainPopup from "../popup-containers/MainPopup";
import DropDown from "../ReusableComponents/DropDown";
import InputText from "../ReusableComponents/InputText";
import TextArea from "../ReusableComponents/TextArea";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import { School } from "../popup-containers/SchoolPopup";
import toast from "react-hot-toast";
import * as XLSX from "sheetjs-style";
import { BindAPI, BindPostAPI, IUDAPI } from "../services/APIConnection";
import GridPage from "../components/GridPage";
import AddScreenTitle from "../components/AddScreenTitle";
import Buttons from "../components/Buttons";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import PopUpButtons from "../components/PopUpButtons";
import { useLocation } from "react-router-dom";
import { useUserCapability } from "../components/ConstantReducerProvider";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import Loader from "../ReusableComponents/Loader";

function SchoolGroup() {
  //All bind dropdown value and bind data value useState hooks handling.
  const location = useLocation();
  const { userProfileState } = useUserCapability();
  const userProfileDatas = userProfileState.userProfile;
  const [schoolData, setSchoolData] = useState("");
  const [bindCountry, setBindCountry] = useState([]);
  const [bindStateDropDown, setBindStateDropDown] = useState([]);
  const [bindLocationDropDown, setBindLocationDropDown] = useState([]);
  const [bindLocationDropDown1, setBindLocationDropDown1] = useState([]);
  const [bindSchoolMasterDatas, setBindSchoolMasterDatas] = useState([]);
  const [getLocationDatas, setGetLocationDatas] = useState([]);

  //All visible functionality useState hooks handling.
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [submitVisibleButton, setSubmitVisibleButton] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // School Master insert and edit useState hooks handling .
  const [mstSchoolId, setMstSchoolId] = useState("");

  const [schoolFields, setSchoolFields] = useState({
    schoolId: "",
    schoolName: "",
    schoolCountry: "",
    schoolState: "",
    schoolLocation: "",
    schoolLocationCode: "",
    schoolMstOrganizationId: "",
    schoolVenue: "",
    schoolContactPerson: "",
    schoolAddress: "",
    schoolMobileNumber: "",
    schoolEmailId: "",
    schoolRemarks: "",
  });
  const [searchInput, setSearchInput] = useState("");
  const [searchData, setFilteredData] = useState(bindSchoolMasterDatas);

  // School Master Error useState hooks handling .

  const [schoolFieldsError, setSchoolFieldsError] = useState({
    schoolIdError: "",
    schoolNameError: "",
    schoolCountryError: "",
    schoolStateError: "",
    schoolLocationError: "",
    schoolVenueError: "",
    schoolContactPersonError: "",
    schoolAddressError: "",
    schoolMobileNumberError: "",
    schoolEmailIdError: "",
    schoolRemarksError: "",
  });

  // Rowindex, Popup, Pagination, next page and other some useState hooks handling.
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [rowIndex, setRowIndex] = useState("");
  const [result, setResult] = useState(10);
  const [popUpDropDownData, setPopUpDropDownData] = useState({});
  const [editMode, setEditMode] = useState([]);
  const createdBy = sessionStorage.getItem("createdBy");
  const [isOpen, setIsOpen] = useState(false);

  //This is School Master grid data bind functionality and School Master dropdown value bind functionality .
  useEffect(() => {
    if (userProfileDatas) {
      fetchAll();
    }
  }, [userProfileDatas]);
  const fetchAll = async () => {
    try {
      setIsLoading(true);

      await Promise.all([
        getSelectedLocation(),
        dropDownDatas(),
        bindSchoolData(userProfileDatas),
      ]);
    } catch (error) {
      console.error("Error fetching initial data", error);
    } finally {
      setIsLoading(false);
    }
  };
  const dropDownDatas = async () => {
    try {
      const [statesResponse, locationResponse] = await Promise.all([
        BindAPI("StateAPI/GetState"),
        BindAPI("LocationAPI/GetLocation"),
      ]);

      const statesData = statesResponse.data.Table.map((item) => ({
        value: item.MstStateId,
        label: item.StateName_en,
      }));
      const locationData = locationResponse.data.Table.map((item) => ({
        value: item.MstLocationId,
        label: item.LocationName_en,
      }));

      setBindStateDropDown(statesData);
      setBindLocationDropDown(locationData);
    } catch (error) {
      console.error("Error fetching dropdown data", error);
    }
  };

  const getSelectedLocation = async () => {
    try {
      const locationResponse = await BindAPI("LocationAPI/GetLocation");
      setGetLocationDatas(locationResponse.data.Table);
    } catch (error) {
      console.error("Error fetching location", error);
    }
  };

  const bindSchoolData = async (userProfileDatas) => {
    if (userProfileDatas && userProfileDatas[0]) {
      try {
        const data = {
          mstOrganizationStructureId: userProfileDatas[0].MstOrganizationId,
          mstBranchId: userProfileDatas[0].MstLocationId,
        };

        const response = await BindPostAPI(
          [data],
          "SchoolCollegeAPI/BindSchool",
        );
        setBindSchoolMasterDatas(response.data.Table);
      } catch (error) {
        console.error("Error fetching school data", error);
      }
    }
  };

  // this function is bind the dropdown value for location what we select in state dropdown that selected related only show the location dropdown .
  useEffect(() => {
    const stateSelectedValue = getLocationDatas.find(
      (item) => item.MstStateId == schoolFields.schoolState,
    );

    if (stateSelectedValue) {
      const locationLabels = getLocationDatas
        .filter((item) => item.MstStateId === stateSelectedValue.MstStateId)
        .map((item) => ({
          MstLocationId: item.MstLocationId,
          LocationName_en: item.LocationName_en,
        }));

      const locationSelected = locationLabels.map((LC) => ({
        value: LC.MstLocationId,
        label: LC.LocationName_en,
      }));
      setBindLocationDropDown1(locationSelected);
    } else {
    }
  }, [schoolFields.schoolState]);

  // This is School grid page add button visible handling functionality .
  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
    setSchoolFields({
      schoolMstOrganizationId: userProfileDatas[0].MstOrganizationId,
      schoolState: userProfileDatas[0].MstStateId,
      schoolLocation: userProfileDatas[0].MstLocationId,
    });
  };

  // This is ovrall cancel button visible handling functionality .
  const cancel = () => {
    setVisibleAdd(false);
    setVisibleTable(true);
    handleOpen(false);
    setSubmitBtnDisabled(false);
    setSubmitVisibleButton(false);
    bindSchoolData(userProfileDatas);
    setIsLoading(false);
    GenerateId();

    setSchoolFields({
      schoolId: "",
      schoolName: "",
      schoolCountry: "",
      schoolState: "",
      schoolLocation: "",
      schoolVenue: "",
      schoolContactPerson: "",
      schoolAddress: "",
      schoolMobileNumber: "",
      schoolEmailId: "",
      schoolRemarks: "",
    });

    setSchoolFieldsError({
      youthGroupIdError: "",
      youthGroupNameError: "",
      youthTypeOfGroupError: "",
      youthStateError: "",
      youthLocationError: "",
      youthVenueError: "",
      youthContactPersonError: "",
      youthMobileNumberError: "",
      youthEmailIdError: "",
    });
  };

  // this function is helped to edit the input value via rowindex passing and helping to visible handling for school.
  const handleEdit = (rowIndex) => {
    setEditMode(true);
    setVisibleAdd(true);
    setVisibleTable(false);
    setUpdateScreenTitle(true);
    setUpdateScreenTitle(true);
    setAddScreenTitle(false);
    setMstSchoolId(bindSchoolMasterDatas[rowIndex].MstSchoolId);

    setSchoolFields({
      schoolId: bindSchoolMasterDatas[rowIndex].SchoolId,
      schoolName: bindSchoolMasterDatas[rowIndex].SchoolName,
      schoolState: bindSchoolMasterDatas[rowIndex].MstStateId,
      schoolLocation: bindSchoolMasterDatas[rowIndex].MstLocationId,
      schoolVenue: bindSchoolMasterDatas[rowIndex].SchoolVenue,
      schoolContactPerson: bindSchoolMasterDatas[rowIndex].SchoolContactPerson,
      schoolAddress: bindSchoolMasterDatas[rowIndex].SchoolAddress,
      schoolMobileNumber: bindSchoolMasterDatas[rowIndex].SchoolPhoneNumber,
      schoolEmailId: bindSchoolMasterDatas[rowIndex].SchoolEmail,
      schoolRemarks: bindSchoolMasterDatas[rowIndex].SchoolRemarks,
    });

    setMstSchoolId(bindSchoolMasterDatas[rowIndex].MstSchoolId);
    setSchoolData(bindSchoolMasterDatas[rowIndex]);
  };

  // This function is helping for Popup open .
  const handleOpen = (isOpen) => {
    setpopUpOpen(isOpen);
  };

  // this function is helped to the viwe, delete, block and unblock input value via rowindex passing for school .
  const handleSchoolDetails = (rowIndex, flag) => {
    handleOpen(true);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setRowIndex(rowIndex);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setRowIndex(rowIndex);
      setUnBlockDetails(true);
    }
    setSchoolData(bindSchoolMasterDatas[rowIndex]);
    setMstSchoolId(bindSchoolMasterDatas[rowIndex].MstSchoolId);

    const SchoolData = bindSchoolMasterDatas[rowIndex];
    //State DropDown Value Start
    const stateDropDownValue = bindStateDropDown.find(
      (item) => item.value === SchoolData.MstStateId,
    );
    const editStateDropDownValue = {
      value: SchoolData.MstStateId,
      label: stateDropDownValue ? stateDropDownValue.label : "Unknown",
    };

    //State DropDown Value End

    //Location DropDown Value Start
    const locationDropDownValue = bindLocationDropDown.find(
      (item) => item.value === SchoolData.MstLocationId,
    );
    const editLocationDropDownValue = {
      value: SchoolData.MstLocationId,
      label: locationDropDownValue ? locationDropDownValue.label : "Unknown",
    };

    //Location DropDown Value End

    const autoDropDownValues = [
      editStateDropDownValue,
      editLocationDropDownValue,
    ];
    setPopUpDropDownData(autoDropDownValues);
    //Area DropDown Value End
  };
  const GenerateId = () => {
    if (addScreenTitle) {
      if (schoolFields.schoolLocation) {
        const filteredBranchProject = getLocationDatas
          .filter((item) => item.MstLocationId === schoolFields.schoolLocation)
          .map((item) => item.LocationCode);
        if (filteredBranchProject.length > 0) {
          setSchoolFields({
            ...schoolFields,
            schoolLocationCode: filteredBranchProject[0],
          });
        }
      }
    }
  };
  useEffect(() => {
    if (addScreenTitle) {
      GenerateId();
    }
  }, [addScreenTitle, schoolFields.schoolLocation]);
  useEffect(() => {
    if (addScreenTitle) {
      if (schoolFields.schoolLocationCode) {
        const outputString = `${schoolFields.schoolLocationCode}/${"SCH"}`;
        setSchoolFields({
          ...schoolFields,
          schoolId: outputString,
        });
      }
    }
  }, [addScreenTitle, schoolFields.schoolLocationCode]);
  const validate = (flag) => {
    // Initialize an object to store validation errors for each field
    const errors = {};

    if (flag === 1 || flag === 2) {
      // Validation logic for the Youth group Name input
      if (!schoolFields.schoolName) {
        errors.schoolName = "Enter Name Of The School / College";
      }
      // Validation logic for the Youth group State input
      if (schoolFields.schoolState == "") {
        errors.schoolState = "Select state";
      }

      // Validation logic for the Youth group Location input
      if (schoolFields.schoolLocation == "") {
        errors.schoolLocation = "Select Branch/Project";
      }

      // Validation logic for the Youth group Venue input
      if (!schoolFields.schoolVenue) {
        errors.schoolVenue = "Enter Venue";
      }

      if (!schoolFields.schoolAddress) {
        errors.schoolAddress = "Enter School / College Address";
      }

      // Validation logic for the Youth group Volunteer input
      if (!schoolFields.schoolContactPerson) {
        errors.schoolContactPerson = "Enter Contact Person Name";
      }

      // Validation logic for the phone input
      if (!schoolFields.schoolMobileNumber) {
        errors.schoolMobileNumber = "Enter Mobile Number";
      } else if (!/^\d{10,11}$/.test(schoolFields.schoolMobileNumber)) {
        errors.schoolMobileNumber = "Enter a valid mobile number";
      }
    }
    setSchoolFieldsError({
      ...schoolFieldsError,
      schoolNameError: errors.schoolName || "",
      schoolStateError: errors.schoolState || "",
      schoolLocationError: errors.schoolLocation || "",
      schoolVenueError: errors.schoolVenue || "",
      schoolContactPersonError: errors.schoolContactPerson || "",
      schoolMobileNumberError: errors.schoolMobileNumber || "",
      schoolEmailIdError: errors.schoolEmailId || "",
      schoolAddressError: errors.schoolAddress || "",
    });

    return errors; // Return the errors object containing validation errors (if any)
  };

  // this function is helped to the edit, viwe, delete, block and unblock flag passing and hanling the API response for those all and passing the rowindex for school.
  const handleSubmit = async (items, flag) => {
    setSubmitBtnDisabled(true);
    if (flag == 1 || flag == 2) {
      const firstNameValidation = validate(flag);

      if (Object.keys(firstNameValidation).length !== 0) {
        setIsOpen(true);
      }

      if (Object.keys(firstNameValidation).length === 0) {
        setIsOpen(false);
        setSubmitBtnDisabled(true);
        setIsLoading(true);
        const data = {
          mstSchoolId: mstSchoolId ? mstSchoolId : 0,
          schoolId: schoolFields.schoolId,
          schoolName: schoolFields.schoolName,
          mstCountryId: 1,
          mstStateId: schoolFields.schoolState,
          mstLocationId: schoolFields.schoolLocation,
          schoolVenue: schoolFields.schoolVenue,
          schoolAddress: schoolFields.schoolAddress,
          schoolContactPerson: schoolFields.schoolContactPerson,
          schoolPhoneNumber: schoolFields.schoolMobileNumber,
          schoolEmail: schoolFields.schoolEmailId,
          schoolRemarks: schoolFields.schoolRemarks,
          createdBy: createdBy,
          flag: flag,
        };
        const response = await IUDAPI([data], "SchoolCollegeAPI/IUDSchool");
        if (flag == 1) {
          // Submit
          if (response.data.Table[0].result === "S") {
            toast.success("School / College data added successfully 👍", {
              duration: 1000,
              position: "top-center",
            });
            setSubmitVisibleButton(true);
            setSchoolFields({
              ...schoolFields,
              schoolId: response.data.Table1[0].SchoolId,
            });
            setTimeout(cancel, 1000);
          } else {
            toast.error("Failed to add School / College data 👎", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        } else if (flag == 2) {
          // Update
          if (response.data.Table[0].result === "M") {
            toast.success("School / College data updated successfully 👍", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          } else {
            toast.error("Failed to update School / College data 👎", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        }
      } else {
        setSubmitBtnDisabled(false);
        setIsLoading(false);
      }
    } else {
      const data = {
        mstSchoolId: bindSchoolMasterDatas[rowIndex].MstSchoolId,
        createdBy: createdBy,
        flag: flag,
      };
      const response = await IUDAPI([data], "SchoolCollegeAPI/IUDSchool");
      if (flag == 3) {
        // Delete
        if (response.data.Table[0].result === "D") {
          toast.success("School / College data deleted successfully 👍", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        } else {
          toast.error("Failed to delete School / College data 👎", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        }
      } else if (flag == 4) {
        // Block
        if (response.data.Table[0].result === "B") {
          toast.success("School / College data blocked successfully 👍", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        } else {
          toast.error("Failed to block School / College data 👎", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        }
      } else if (flag == 5) {
        // Unblock
        if (response.data.Table[0].Result === "UB") {
          toast.success("School / College data unblocked successfully 👍", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        } else {
          toast.error("Failed to unblock School / College data 👎", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        }
      }
    }
  };

  const handleSearch = (input) => {
    const filtered = bindSchoolMasterDatas.filter((item) => {
      const providerData = `${item.SchoolName}${item.SchoolId}${item.SchoolContactPerson}`;
      return providerData.toLowerCase().includes(input.toLowerCase());
    });
    setFilteredData(filtered);
  };
  useEffect(() => {
    if (location.pathname == "/schoolgroup") {
      setAddScreenTitle(false);
      setVisibleTable(true);
      setVisibleAdd(false);
    }
  }, [location]);

  const handleSchoolFieldsChange = (value, name) => {
    setSchoolFields({
      ...schoolFields,
      [name]: value,
    });
  };
  const handleExport = async () => {
    try {
      if (userProfileDatas?.[0]) {
        const data = {
          mstOrganizationStructureId: userProfileDatas[0].MstOrganizationId,
          mstBranchId: userProfileDatas[0].MstLocationId,
        };

        const response = await BindPostAPI(
          [data],
          "SchoolCollegeAPI/BindSchoolExport",
        );
        const rows = response?.data?.Table || [];
        if (rows.length === 0) {
          await IUDAPI(
            {
              mstUserId: parseInt(createdBy, 10),
              sp: "SCHOOL / COLLEGE MASTER",
              action: "EXCEL EXPORT",
              status: "FAILED",
              tableName: "mst_school",
              description: "No data available to export",
            },
            "Log/IUDLog",
          );

          toast.error("No data available to export", {
            duration: 1000,
            position: "top-center",
          });

          return;
        } else {
          await IUDAPI(
            {
              mstUserId: parseInt(createdBy, 10),
              sp: "SCHOOL / COLLEGE MASTER",
              action: "EXCEL EXPORT",
              status: "SUCCESS",
              tableName: "mst_school",
              description: `School/College Excel exported successfully. Total Records: ${rows.length}`,
            },
            "Log/IUDLog",
          );
        }
        exportData(
          schoolMasterExportHeaders.map((col) => col.title),
          rows,
        );
      }
    } catch (error) {
      console.error("Export error", error);
      await IUDAPI(
        {
          mstUserId: parseInt(createdBy, 10),
          sp: "SCHOOL / COLLEGE MASTER",
          action: "EXCEL EXPORT",
          status: "FAILED",
          tableName: "mst_school",
          description: "Failed to export School / College data",
        },
        "Log/IUDLog",
      );
      toast.error("Failed to export Excel 👎", {
        duration: 1000,
        position: "top-center",
      });
    }
  };
  const exportData = (columns, rows) => {
    /* ---------- TITLE ---------- */
    const titleRow = [
      {
        v: "School / College",
        s: {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "left" },
        },
      },
    ];

    const spacingRow = [{ v: "" }];

    /* ---------- HEADER ---------- */
    const headerRow = columns.map((col) => ({
      v: col,
      s: {
        fill: { fgColor: { rgb: "2D2D6E" } },
        font: { bold: true, color: { rgb: "FFFFFF" } },
        alignment: { horizontal: "left", wrapText: true },
      },
    }));

    /* ---------- DATA ROWS ---------- */
    const dataRows = rows.map((row, index) => {
      const baseStyle =
        index % 2 === 1 ? { fill: { fgColor: { rgb: "F2F2F2" } } } : {};

      return [
        { v: index + 1, s: baseStyle }, // S.No
        { v: row.MstSchoolId, s: baseStyle },
        { v: row.SchoolId, s: baseStyle },
        { v: row.SchoolName, s: baseStyle },
        { v: row.StateName_en, s: baseStyle },
        { v: row.LocationName_en, s: baseStyle },
        { v: row.SchoolVenue, s: baseStyle },
        { v: row.SchoolContactPerson, s: baseStyle },
        { v: row.SchoolAddress, s: baseStyle },
        { v: row.SchoolPhoneNumber, s: baseStyle },
        { v: row.SchoolEmail, s: baseStyle },
        { v: row.SchoolRemarks, s: baseStyle },
        { v: row.FullName_en, s: baseStyle },
      ];
    });

    /* ---------- SHEET DATA ---------- */
    const wsData = [titleRow, spacingRow, headerRow, ...dataRows];

    const ws = XLSX.utils.aoa_to_sheet(wsData);

    /* ---------- DYNAMIC COLUMN WIDTHS (CORRECT) ---------- */
    ws["!cols"] = columns.map((header, colIndex) => {
      // start with header text length
      let maxLength = header?.length || 10;

      // check each exported row
      dataRows.forEach((rowArray) => {
        const cell = rowArray[colIndex]?.v;

        if (cell !== null && cell !== undefined) {
          maxLength = Math.max(maxLength, cell.toString().length);
        }
      });

      return {
        width: Math.min(Math.max(maxLength + 2, 10), 40),
      };
    });

    /* ---------- ROW HEIGHTS ---------- */
    ws["!rows"] = [
      { hpt: 30 }, // Title
      { hpt: 15 }, // Space
      { hpt: 22 }, // Header
      ...Array(rows.length).fill({ hpt: 18 }),
    ];

    /* ---------- BORDERS ---------- */
    const range = XLSX.utils.decode_range(ws["!ref"]);
    for (let R = range.s.r; R <= range.e.r; R++) {
      for (let C = range.s.c; C <= range.e.c; C++) {
        const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
        if (!ws[cellRef]) continue;

        ws[cellRef].s = {
          ...ws[cellRef].s,
          border: {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
          },
        };
      }
    }

    /* ---------- WORKBOOK ---------- */
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "School College");

    XLSX.writeFile(wb, "School_College.xlsx");
  };
  return (
    <MainLayout pageName="2">
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        <GridPage
          title="School / College"
          header={schoolMasterHeaders}
          records={bindSchoolMasterDatas}
          blockView={true}
          handleEdit={handleEdit}
          handleAction={handleSchoolDetails}
          handleExportBtn={true}
          handleExport={handleExport}
          showAdd={showAdd}
        />
      )}
      {visibleAdd && (
        <div className="flex flex-col w-full">
          <div className={mainTable.mainAddScreen}>
            <AddScreenTitle
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
              title="School / College"
            />
            <div className={mainTable.addShadowScreen}>
              <div className={mainTable.mainContentScreen}>
                <form className={mainTable.formForClientMaster}>
                  <div>
                    <div class={mainTable.labelBold1}>School / College</div>
                    <hr class={mainTable.horizontalLine}></hr>
                    <div className={mainTable.grid3}>
                      <div>
                        <InputText
                          classStar="text-red-500"
                          inputType="text"
                          title="School / College Id"
                          name="schoolID"
                          maxLength={30}
                          placeholder={"MAD/SCH/2024/00001"}
                          content={schoolFields.schoolId}
                          controlFunc={(e) =>
                            setSchoolFields({
                              ...schoolFields,
                              schoolId: e.target.value,
                            })
                          }
                          disabled={true}
                        />
                      </div>
                      <div>
                        <InputText
                          classStar="text-red-500"
                          inputType="text"
                          title="Name Of The School / College"
                          name="schoolName"
                          maxLength={100}
                          content={schoolFields.schoolName}
                          controlFunc={(e) => {
                            const value = e.target.value;
                            setSchoolFields({
                              ...schoolFields,
                              schoolName: value,
                            });
                            setSchoolFieldsError((schoolFieldsError) => ({
                              ...schoolFieldsError,
                              schoolNameError:
                                value.trim().length > 0

                                  ? ""
                                  : "Enter Name Of The School / College",
                            }));
                          }}
                          controlFuncBlur={(e) => {
                            const trimmedValue = e.target.value.trim();
                            setSchoolFields({
                              ...schoolFields,
                              schoolName: trimmedValue,
                            });
                            setSchoolFieldsError((schoolFieldsError) => ({
                              ...schoolFieldsError,
                              schoolNameError:
                                trimmedValue.length > 0

                                  ? ""
                                  : "Enter Name Of The School / College",
                            }));
                          }}
                          errorMessage={schoolFieldsError.schoolNameError}
                        />
                      </div>
                      <DropDown
                        classDiv="hidden"
                        title="Country"
                        options={bindCountry}
                        placeholder="Select"
                        name="country"
                        selectedOption={schoolFields.schoolCountry}
                        controlFunc={(e) =>
                          setSchoolFields({
                            ...schoolFields,
                            schoolCountry: e.target.value,
                          })
                        }
                      />
                      <div>
                        <AutoDropDown
                          classStar="text-red-500"
                          title="State"
                          options={bindStateDropDown}
                          placeholder="Select"
                          name="schoolState"
                          Class="custom-class"
                          tabIndex="1"
                          disabled={
                            schoolFields.schoolMstOrganizationId == 1
                              ? false
                              : true
                          }
                          selectedOption={bindStateDropDown.find(
                            (x) => x.value == schoolFields.schoolState,
                          )}
                          controlFunc={(value, e) => {
                            handleSchoolFieldsChange(value.value, e.name);
                            setSchoolFields({
                              ...schoolFields,
                              schoolState: value.value,
                              schoolLocation: "",
                            });
                          }}
                          controlFuncBlur={() => {
                            setSchoolFieldsError({
                              ...schoolFieldsError,
                              schoolStateError: schoolFields.schoolState
                                ? ""
                                : "Select State",
                            });
                          }}
                          errorMessage={schoolFieldsError.schoolStateError}
                          setError={setSchoolFieldsError}
                        />
                      </div>
                      <div>
                        <AutoDropDown
                          classStar="text-red-500"
                          title="Branch/Project"
                          options={
                            bindLocationDropDown && bindLocationDropDown1
                          }
                          disabled={
                            schoolFields.schoolMstOrganizationId == 1
                              ? false
                              : true
                          }
                          placeholder="Select"
                          name="schoolLocation"
                          selectedOption={
                            schoolFields.schoolLocation
                              ? bindLocationDropDown.find(
                                (x) => x.value == schoolFields.schoolLocation,
                              )
                              : ""
                          }
                          Class="custom-class"
                          tabIndex="1"
                          controlFunc={(value, e) => {
                            handleSchoolFieldsChange(value.value, e.name);
                          }}
                          controlFuncBlur={() => {
                            setSchoolFieldsError(() => ({
                              ...schoolFieldsError,
                              schoolLocationError: schoolFields.schoolLocation
                                ? ""
                                : "Select Branch/Project",
                            }));
                          }}
                          errorMessage={schoolFieldsError.schoolLocationError}
                          setError={setSchoolFieldsError}
                        />
                      </div>
                      <div>
                        <InputText
                          classStar="text-red-500"
                          inputType={"text"}
                          title={"Place"}
                          name={"venue"}
                          maxLength={100}
                          content={schoolFields.schoolVenue}
                          controlFunc={(e) => {
                            const value = e.target.value;
                            setSchoolFields({
                              ...schoolFields,
                              schoolVenue: value,
                            });
                            setSchoolFieldsError((schoolFieldsError) => ({
                              ...schoolFieldsError,
                              schoolVenueError:
                                value.trim().length > 0

                                  ? ""
                                  : "Enter Venue",
                            }));
                          }}
                          controlFuncBlur={(e) => {
                            const trimmedValue = e.target.value.trim();
                            setSchoolFields({
                              ...schoolFields,
                              schoolVenue: trimmedValue,
                            });
                            setSchoolFieldsError((schoolFieldsError) => ({
                              ...schoolFieldsError,
                              schoolVenueError:
                                trimmedValue.length > 0

                                  ? ""
                                  : "Enter Venue",
                            }));
                          }}
                          errorMessage={schoolFieldsError.schoolVenueError}
                        />
                      </div>
                      <div>
                        <InputText
                          classStar="text-red-500"
                          inputType={"text"}
                          title={"Contact Person Name"}
                          name={"contactPerson"}
                          maxLength={100}
                          content={schoolFields.schoolContactPerson}
                          controlFunc={(e) => {
                            const value = e.target.value;
                            setSchoolFields({
                              ...schoolFields,
                              schoolContactPerson: value,
                            });
                            setSchoolFieldsError((schoolFieldsError) => ({
                              ...schoolFieldsError,
                              schoolContactPersonError:
                                value.trim().length > 0

                                  ? ""
                                  : "Enter Contact Person Name",
                            }));
                          }}
                          controlFuncBlur={(e) => {
                            const trimmedValue = e.target.value.trim();
                            setSchoolFields({
                              ...schoolFields,
                              schoolContactPerson: trimmedValue,
                            });
                            setSchoolFieldsError((schoolFieldsError) => ({
                              ...schoolFieldsError,
                              schoolContactPersonError:
                                trimmedValue.length > 0

                                  ? ""
                                  : "Enter Contact Person Name",
                            }));
                          }}
                          errorMessage={
                            schoolFieldsError.schoolContactPersonError
                          }
                        />
                      </div>
                      <div className="col-span-3">
                        <InputText
                          inputType={"text"}
                          title={"School / College Address"}
                          name={"address"}
                          maxLength={200}
                          classStar="text-red-500"
                          content={schoolFields.schoolAddress}
                          placeholder=""
                          controlFunc={(e) => {
                            const value = e.target.value;
                            setSchoolFields({
                              ...schoolFields,
                              schoolAddress: value,
                            });
                            setSchoolFieldsError((schoolFieldsError) => ({
                              ...schoolFieldsError,
                              schoolAddressError:
                                value.trim().length > 0
                                  ? ""
                                  : "Enter School / College Address",
                            }));
                          }}
                          controlFuncBlur={(e) => {
                            const trimmedValue = e.target.value.trim();
                            setSchoolFields({
                              ...schoolFields,
                              schoolAddress: trimmedValue,
                            });
                            setSchoolFieldsError((schoolFieldsError) => ({
                              ...schoolFieldsError,
                              schoolAddressError:
                                trimmedValue.length > 0
                                  ? /^[\S]+(?:\s[\S]+)*$/.test(trimmedValue)
                                    ? "" // No error if the input is valid
                                    : "Only single spaces between words allowed"
                                  : "Enter School / College Address", // Error message if the input is empty
                            }));
                          }}
                          errorMessage={schoolFieldsError.schoolAddressError}
                        />
                      </div>
                      <div>
                        <InputText
                          classStar="text-red-500"
                          inputType={"text"}
                          title={"Mobile Number"}
                          name={"phone"}
                          maxLength={11}
                          content={schoolFields.schoolMobileNumber}
                          controlFunc={(e) =>
                            setSchoolFields({
                              ...schoolFields,
                              schoolMobileNumber: e.target.value.trim(),
                            })
                          }
                          controlFuncBlur={(e) => {
                            setSchoolFieldsError((schoolFieldsError) => ({
                              ...schoolFieldsError,
                              schoolMobileNumberError:
                                schoolFields.schoolMobileNumber &&
                                  schoolFields.schoolMobileNumber.length > 0
                                  ? /^\d{10,11}$/.test(
                                    schoolFields.schoolMobileNumber,
                                  )
                                    ? ""
                                    : "Enter Valid Mobile Number"
                                  : "Enter Mobile Number",
                            }));
                          }}
                          errorMessage={
                            schoolFieldsError.schoolMobileNumberError
                          }
                        />
                      </div>
                      <div>
                        <InputText
                          inputType={"text"}
                          title={"Email Id"}
                          name={"email"}
                          maxLength={150}
                          content={schoolFields.schoolEmailId}
                          controlFunc={(e) =>
                            setSchoolFields({
                              ...schoolFields,
                              schoolEmailId: e.target.value,
                            })
                          }
                        />
                      </div>
                      <div class="md:col-span-3 col-span-1">
                        <TextArea
                          inputType="text"
                          title="Remarks"
                          name="remarks"
                          rows={4}
                          maxLength={500}
                          content={schoolFields.schoolRemarks}
                          controlFunc={(e) =>
                            setSchoolFields({
                              ...schoolFields,
                              schoolRemarks: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                  </div>
                </form>
                <Buttons
                  addScreenTitle={addScreenTitle}
                  updateScreenTitle={updateScreenTitle}
                  handleSubmit={handleSubmit}
                  cancel={cancel}
                  disabledBtn={submitBtnDisabled ? true : false}
                />
                {submitVisibleButton && (
                  <div className="border p-2 flex flex-col items-center justify-center ">
                    <label className="flex gap-1  mb-2 text-sm font-medium text-neutral-700 ">
                      School / College Id :
                      <span className=" mb-2 text-sm font-bold text-neutral-700 ">
                        {schoolFields.schoolId}
                      </span>
                    </label>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={handleSchoolDetails}
      >
        <div className=" w-full">
          <PopUpScreenTitle
            title="School / College"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />

          <School data={schoolData} data2={popUpDropDownData} />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled ? true : false}
        />
      </MainPopup>
    </MainLayout>
  );
}

export default SchoolGroup;
